module.exports = __webpack_public_path__ + "static/media/hw_o_5.cef2052b.flv";